import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import ReCaptcha from 'react-google-recaptcha';

/**
 * reCAPTCHA v2 checkbox wrapper.
 * Uses forwardRef so the parent can call ref.current.reset() after submission.
 */
const Captcha = forwardRef(
    (
        { size = 'normal', theme = 'light', onVerify, onExpired, onError },
        ref
    ) => {
        const apiKey = process.env.REACT_APP_RECAPTCHA_API_KEY;

        if (!apiKey) {
            return (
                <p className="text-muted small">reCAPTCHA is not configured.</p>
            );
        }

        return (
            <ReCaptcha
                ref={ref}
                sitekey={apiKey}
                size={size}
                theme={theme}
                onChange={onVerify}
                onExpired={onExpired}
                onError={onError}
            />
        );
    }
);
Captcha.displayName = 'Captcha';

Captcha.propTypes = {
    size: PropTypes.oneOf(['normal', 'compact']),
    theme: PropTypes.oneOf(['light', 'dark']),
    onVerify: PropTypes.func.isRequired,
    onExpired: PropTypes.func,
    onError: PropTypes.func,
};

export default Captcha;
